import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import { API_BASE_URL } from "../../config";

import NearbyVmList from "./NearbyVmList";
import RecentVmList from "./RecentVmList";
import NoVmFound from "./NoVmFound";
import { Box } from "@mui/material";
import Banner_Container from "../../Banners/container";
import SearchBar from "./SearchVm";
import LocationPage from "./LocationPage";
import Game from "../Game/component";
import TopNavbar from "./header";
import QrModal from "./Qr";
import BottomNarBar from "../../BottomNav/Bottom";
import Procced from "../../ProccedToPay/component";
import PendingPickup from "../PendingPickup/component";
import CategoryItem from "./Category/component";
import NoActiveMachine from "../VmInventory/NoActiveMachine";
import ReplaceCartModal from "../../PopUp/ReplaceCartPopUp";
import WaitingLoder from "../../Loader/component";
import LoyaltyCongratsDialog from "./LoyaltyCongratsDialog";
import NoInternet from "../../NoInterNet/component";
import ServerErrorPage from "../../ServerError/ServerErrorPage";

// ─── Helpers ──────────────────────────────────────────────────────────────────

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("UserJWTAuth")}`,
  "x-app-platform": "web",
  "x-app-version": "v1.0.1",
  "x-device-id": localStorage.getItem("uuid") || "",
});

const mapSlotsWithMyCount = (vmList = [], cartItems = [], preCardMachineId) =>
  vmList.map((vm) => ({
    ...vm,
    slotDetails: vm.slotDetails.map((slot) => {
      const isCartMachine = preCardMachineId == vm.vmId;
      const matchedItem = isCartMachine
        ? cartItems.find((item) => item.slotId === slot.slotId)
        : null;
      return { ...slot, myCount: matchedItem ? matchedItem.count : 0 };
    }),
  }));

const getBottomPadding = (activeOrders, preCart) => {
  const hasActive = activeOrders?.length > 0;
  const hasCart = preCart?.length > 0;
  if (hasCart && hasActive) return "135px";
  if (hasCart) return "50px";
  if (hasActive && activeOrders.length > 1) return "115px";
  if (hasActive) return "80px";
  return "0px";
};

// ─── Component ────────────────────────────────────────────────────────────────

const VmlistContainer = () => {
  const { makeApiRequest } = useApiRequest();
  const navigate = useNavigate();
  const location = useLocation();

  // ── VM lists ───────────────────────────────────────────────
  const [nearbyVmlist, setNearbyVmlist] = useState([]);
  const [recentVmlist, setRecentVmlist] = useState([]);
  const [loading, setLoading] = useState(false);

  // ── Cart ───────────────────────────────────────────────────
  const [preCart, setPreCart] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [preCardMachineId, setPreCardMachineId] = useState(null);
  const [replaceSlot, setReplaceSlot] = useState(null);
  const [replaceCard, setReplaceCard] = useState(false);
 const [serverError,      setServerError]      = useState(false);
  // ── Orders ─────────────────────────────────────────────────
  const [activeOrders, setActiveOrders] = useState([]);

  // ── Categories ─────────────────────────────────────────────
  const [categories, setCategories] = useState([]);
  const [categoriesId, setCategoriesId] = useState(null);
  const [categoriesWiseVmItems, setCategoriesWiseVmItems] = useState([]);

  // ── User / loyalty ─────────────────────────────────────────
  const [userDetails, setUserDetails] = useState(null);
  const [milestoneData, setMilestoneData] = useState({
    currentLevelMilestoneCount: 0,
    reward: null,
    levelId: 1,
  });
  const [openCongrats, setOpenCongrats] = useState(false);

  // ── UI state ───────────────────────────────────────────────
  const [loader, setLoader] = useState(false);
  const [showLocation, setShowLocation] = useState(true);
  const [qrModelFlag, setQrModelFlag] = useState(false);
  const [machineUuidFlag, setMachineUuidFlag] = useState(false);
  const [uuidVmId, setUuidVmId] = useState(null);
  const [viewAll, setViewAll] = useState(false);
  const [noInternet, setNoInternet] = useState(false);

  // ─── Network error handler ─────────────────────────────────────────────────

  const handleNetworkError = useCallback((error) => {
    
     if(handleServerError(error)) return
    if (error.code === "ERR_NETWORK" || !error.response) {
      setNoInternet(true);
      setLoader(false);
      return true;
    }
    return false;
  }, []);



    const handleServerError = useCallback((error) => {
      console.log("Error response for debugging:", error.response.status);
    const statusCode = error?.response?.data?.status?.code;
  
    if (
      statusCode === "INTERNAL_SERVER_ERROR" ||
      error?.response?.status === 500|| error.response.status === 502
    ) {
      console.log("Server Error:", statusCode);
  
      setServerError(true); // 👈 state create karo
      setLoader(false);
      return true;
    }
  
    return false;
  }, []);

  // ─── Online / offline listeners ───────────────────────────────────────────

  useEffect(() => {
    if (!navigator.onLine) {
      setNoInternet(true);
      setLoader(false);
    }

    const goOffline = () => setNoInternet(true);
    const goOnline = () => {
      setNoInternet(false);
   
          fetchPreCart();
    fetchActiveOrders();
    fetchCategories();
    getLocation()
      setLoader(false);
  
    };

    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  // ─── Auth guard ───────────────────────────────────────────────────────────

  useEffect(() => {
    const token = localStorage.getItem("UserJWTAuth");
    if (!token) {
      navigate("/login", { state: { from: location.pathname + location.search } });
      return;
    }
    if (localStorage.getItem("Guest_clientId")) {
     // navigate("/login", { state: { from: location.pathname + location.search } });
    }
  }, []);

  // ─── Bootstrap ────────────────────────────────────────────────────────────

  useEffect(() => {
    const lat = localStorage.getItem("lat");
    const lng = localStorage.getItem("lng");
    if (lat && lng && navigator.onLine) fetchVmList(lat, lng);
  }, []);

  useEffect(() => {
    if (!navigator.onLine) return;
     const Guest_OauthToken = localStorage.getItem("Guest_OauthToken");
     if(!Guest_OauthToken){
    fetchUserDetails();
     }
    fetchPreCart();
    fetchActiveOrders();
    fetchCategories();
    getLocation()
  }, []);

  // ─── VM list ──────────────────────────────────────────────────────────────

  const getLocation = () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by this browser.", { autoClose: 2000 });
      return;
    }
    navigator.geolocation.getCurrentPosition(
      ({ coords: { latitude, longitude } }) => {
        localStorage.setItem("lat", latitude);
        localStorage.setItem("lng", longitude);
        fetchVmList(latitude, longitude);
      },
      (error) => {
        const messages = {
          1: "User denied the request for Geolocation",
          2: "Location information is unavailable",
          3: "The request to get user location timed out",
        };
        toast.error(messages[error.code] || "An unknown error occurred", { autoClose: 2000 });
      }
    );
  };

  const fetchVmList = (lat, lng) => {
    setShowLocation(false);
    setLoading(true);
    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/outlet/search?nearbyLimit=50&recentLimit=6&lat=${lat}&lng=${lng}`,
      method: "GET",
      headers: getAuthHeaders(),
      handleSuccess: (res) => {
        setNearbyVmlist(res?.data?.data?.nearbyMachines || []);
        setRecentVmlist(res?.data?.data?.recentMachines || []);
        setLoading(false);
      },
      handleError: (error) => {
        if (handleNetworkError(error)) return;
        toast.error("Failed to load vending machines.", { autoClose: 1500 });
        setLoading(false);
      },
    });
  };

  const fetchMachineByUUID = (uuid) => {
    setUuidVmId(uuid);
    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/outlet/machinebyuuid/${uuid}`,
      method: "GET",
      headers: getAuthHeaders(),
      handleSuccess: (res) => {
        const machineId = res?.data?.data?.machineId;
        if (machineId) {
          navigate(`/items?machineId=${machineId}&value=${uuid}`, {
            state: { from: location.pathname + location.search },
          });
        } else {
          toast.error("Machine not found for this device", { position: "top-right", autoClose: 1500 });
        }
      },
      handleError: (error) => {
        if (handleNetworkError(error)) return;
        const code = error?.response?.data?.status?.code;
        setMachineUuidFlag(true);
        if (code === "UNAUTHORIZED") {
          navigate(`/login?value=${uuid}`, {
            state: { from: location.pathname + location.search },
          });
        }
      },
    });
  };

  // ─── User / loyalty ───────────────────────────────────────────────────────

  const fetchUserDetails = () => {
    const token = localStorage.getItem("UserJWTAuth");
    if (!token) return;

    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/user/loyalty/details`,
      method: "GET",
      headers: getAuthHeaders(),
      handleSuccess: (res) => {
        const userData = res?.data?.data;
        setUserDetails(userData);

        const reward =
          userData?.levelRewards?.find(
            (item) => item.milestoneCount === userData.currentLevelMilestoneCount
          ) || false;

        const milestone = {
          currentLevelMilestoneCount: userData.currentLevelMilestoneCount,
          reward,
          levelId: userData.levelId,
        };
        setMilestoneData(milestone);

        const uniqueKey = `levelId_${userData.levelId}_milestone_${userData.currentLevelMilestoneCount}`;
        if (localStorage.getItem("lastShownMilestone") !== uniqueKey) {
          setOpenCongrats(true);
        }
      },
      handleError: (error) => {
        handleNetworkError(error);
      },
    });
  };

  const handleCloseCongrats = () => {
    const key = `levelId_${milestoneData.levelId}_milestone_${milestoneData.currentLevelMilestoneCount}`;
    localStorage.setItem("lastShownMilestone", key);
    setOpenCongrats(false);
  };

  // ─── Cart ─────────────────────────────────────────────────────────────────

  const fetchPreCart = () => {
    const token = localStorage.getItem("UserJWTAuth");
    if (!token) return;

    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/cart`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      handleSuccess: (res) => {
        const data = res?.data?.data || {};
        const items = data?.items || [];
        const machineId = res?.headers?.["machineid"];

        setPreCardMachineId(machineId);
        localStorage.setItem("machineId", machineId);

        const total = items.reduce((sum, item) => sum + item.amount * item.count, 0);
        setTotalAmount(total);
        setPreCart(items);

        if (categoriesId) fetchCategoriesWise(categoriesId, items, machineId);
      },
      handleError: (error) => {
         if(handleServerError(error)) return
        if (error.response?.status === 401 || error.response?.status === 403) {
          localStorage.removeItem("UserJWTAuth");
        } else {
          toast.error(`${error.response?.data?.status?.code || "Error"}`, {
            position: "top-right",
            autoClose: 1000,
          });
        }
      },
    });
  };

  const handleCartOperation = (e, index, slot_id, currentCount, operation, machineId) => {
    e.stopPropagation();
    setLoader(true);

    const token = localStorage.getItem("UserJWTAuth");
    const payloadCount = operation === "add" ? currentCount + 1 : currentCount - 1;

    if (preCart?.length > 0) setReplaceSlot({ slot_id, index, machineId });

    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/cart?machineId=${machineId}&replace-cart=${replaceCard}`,
      method: "PATCH",
      headers: { Authorization: `Bearer ${token}` },
      data: [{ slotId: parseInt(slot_id), count: payloadCount }],
      handleSuccess: (res) => {
        setLoader(false);
        localStorage.setItem("card_id", res.headers["cart-id"]);
        setPreCart(res?.data?.data?.items || []);
        fetchPreCart();
      },
      handleError: (error) => {
        if (handleNetworkError(error)) return;
        setLoader(false);
        if (error.response?.data?.status?.message === "Cart contains items from another machine") {
          setReplaceCard(true);
        }
        toast.error(`${error.response?.data?.status?.message}`, {
          position: "top-right",
          autoClose: 1500,
        });
      },
    });
  };

  const replaceMyCardFun = (e) => {
    setReplaceCard(false);
    if (replaceSlot) {
      handleCartOperation(e, replaceSlot.index, replaceSlot.slot_id, 0, "add", replaceSlot.machineId);
    }
  };

  // ─── Active orders ────────────────────────────────────────────────────────

  const fetchActiveOrders = () => {
    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/order/active`,
      method: "GET",
      headers: getAuthHeaders(),
      handleSuccess: (res) => setActiveOrders(res?.data?.data || []),
      handleError: (error) => handleNetworkError(error),
    });
  };

  // ─── Categories ───────────────────────────────────────────────────────────

  const fetchCategories = () => {
    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/item/category`,
      method: "GET",
      headers: getAuthHeaders(),
      handleSuccess: (res) => {
        setCategories(res?.data?.data || []);
        setLoader(false);
      },
      handleError: (error) => {
        if (handleNetworkError(error)) return;
        setLoader(false);
      },
    });
  };

  const fetchCategoriesWise = (id, cartItems, preMachineId) => {
    setCategoriesId(id);
    makeApiRequest({
      url: `${API_BASE_URL}/consumerbe/api/v2/outlet-wise/inventory?page=0&size=100&lat=${localStorage.getItem("lat")}&lng=${localStorage.getItem("lng")}&categoryId=${id}`,
      method: "GET",
      headers: getAuthHeaders(),
      handleSuccess: (res) => {
        const mapped = mapSlotsWithMyCount(
          res?.data?.data,
          cartItems ?? preCart,
          preMachineId
        );
        setCategoriesWiseVmItems(mapped);
        setLoader(false);
      },
      handleError: (error) => {
         if(handleServerError(error)) return
        if (handleNetworkError(error)) return;
        setLoader(false);
      },
    });
  };

  // ─── QR ───────────────────────────────────────────────────────────────────

  const showQRFun = () => setQrModelFlag(true);
  const closeQrFun = () => setQrModelFlag(false);
  const goToHome = () => setMachineUuidFlag(false);

  // ─── Early returns ────────────────────────────────────────────────────────

  if (noInternet) return <NoInternet />;
  if (showLocation) return <LocationPage fetchVmList={fetchVmList} setshowLoction={setShowLocation} />;
  if (machineUuidFlag) return <NoActiveMachine uuid={uuidVmId} gotohome={goToHome} />;
  console.log("serverError",serverError)
    if(serverError) return <ServerErrorPage/>


  // ─── Render ───────────────────────────────────────────────────────────────

  return (
    <>
      <LoyaltyCongratsDialog
        open={openCongrats}
        onClose={handleCloseCongrats}
        medalImage={milestoneData?.levelImage}
        milestoneData={milestoneData}
      />

      {loader && <WaitingLoder />}

      {qrModelFlag ? (
        <QrModal
          ShowQRFun={showQRFun}
          qrModelflag={qrModelFlag}
          CloseQrFun={closeQrFun}
          fetchMachineByUUID={fetchMachineByUUID}
        />
      ) : (
        <>
          {replaceCard && (
            <ReplaceCartModal
              replaceMyCardFun={replaceMyCardFun}
              setReplaceCard={setReplaceCard}
            />
          )}

          <TopNavbar
            LoctionPinHeader
            QrMarkHeader
            shareLocation={getLocation}
            ShowQRFun={showQRFun}
            preCart={preCart}
          />

          <Box
            sx={{
              padding: 2,
              position: "relative",
              minHeight: "100vh",
              background:
                "radial-gradient(circle, rgba(245,233,233,0.4) 0%, rgba(185,245,247,0.34) 100%)",
              overflow: "hidden",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0,0,0,0.1)",
                zIndex: 0,
                animation: "fadeOverlay 5s ease-in-out infinite alternate",
              },
              "@keyframes fadeOverlay": {
                from: { opacity: 0.2 },
                to: { opacity: 0.4 },
              },
            }}
          >
            <Box sx={{ position: "relative", zIndex: 1 }}>
              {userDetails && <Game data={userDetails} />}

              <Banner_Container vmid={0} />
              <SearchBar />

              <CategoryItem
                categories={categories}
                fetchCategoriesWise={fetchCategoriesWise}
                categoriesWiseVmItems={categoriesWiseVmItems}
                setCategoriesWiseVmItems={setCategoriesWiseVmItems}
                handleCartOpertation={handleCartOperation}
                setViewall={setViewAll}
                viewall={viewAll}
              />

              <div style={{ paddingBottom: getBottomPadding(activeOrders, preCart) }}>
                {recentVmlist.length > 0 && (
                  <RecentVmList
                    recentVmlist={recentVmlist}
                    loading={loading}
                    onFetchLocation={getLocation}
                  />
                )}
                {nearbyVmlist.length > 0 && (
                  <NearbyVmList
                    nearbyVmlist={nearbyVmlist}
                    loading={loading}
                    onFetchLocation={getLocation}
                  />
                )}
              </div>

              {nearbyVmlist.length === 0 && recentVmlist.length === 0 && <NoVmFound />}
            </Box>
          </Box>

          {preCart?.length > 0 && (
            <Procced preCart={preCart} totalAmount={totalAmount} bottom="90px" page="vmlist" />
          )}
          {activeOrders?.length > 0 && (
            <PendingPickup activeOrders={activeOrders} preCart={preCart} page="vmlist" />
          )}

          <BottomNarBar />
        </>
      )}
    </>
  );
};

export default VmlistContainer;